import bgBoxLegendary from 'assets/img/bg_box_legendary.png';
import bgBoxCommon from 'assets/img/bg_box_common.png';
import bgBoxEpic from 'assets/img/bg_box_epic.png';
import bgOpenBox from 'assets/img/bg_open_box.png';
import icTHC from 'assets/img/thetan_coin.png';
import icPP from 'assets/img/power_point.png';
import icTHG from 'assets/img/thetan_gem.png';
import styles from './styles.module.scss';
import { BoxConfigRefType, CosmeticRarity, NftItemRarity } from '@profile/src/utils/types';
import { CurrencyType } from '@wolffun/system-currency';
export const heroMap = {
  [NftItemRarity.COMMON]: {
    style: styles.common,
    rarity: NftItemRarity.COMMON,
    image: bgBoxCommon
  },
  [NftItemRarity.EPIC]: {
    style: styles.epic,
    rarity: NftItemRarity.EPIC,
    image: bgBoxEpic
  },
  [NftItemRarity.LEGENDARY]: {
    style: styles.legendary,
    rarity: NftItemRarity.LEGENDARY,
    image: bgBoxLegendary
  }
};
export const cosmeticMap = {
  [CosmeticRarity.COMMON]: {
    style: styles.common,
    image: bgBoxCommon,
    glowStyle: styles.glowCommon
  },
  [CosmeticRarity.EPIC]: {
    style: styles.epic,
    image: bgBoxEpic,
    glowStyle: styles.glowEpic
  },
  [CosmeticRarity.LEGENDARY]: {
    style: styles.legendary,
    image: bgBoxLegendary,
    glowStyle: styles.glowLegendary
  }
};
export const currencyMap = {
  [CurrencyType.GPP]: {
    style: styles.powerpoint,
    image: icPP,
    name: 'Powerpoint'
  },
  [CurrencyType.THC]: {
    style: '',
    image: icTHC,
    name: ''
  },
  [CurrencyType.THG]: {
    style: '',
    image: icTHG,
    name: ''
  },
  [CurrencyType.BUSD]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.BUSDT]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.BNB]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.GPT]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.GMQP]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.GOLD]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.WBNB]: {
    style: '',
    image: '',
    name: ''
  },
  [CurrencyType.GTHC]: {
    style: styles.thc,
    image: icTHC,
    name: 'THC'
  },
  [CurrencyType.GTHG]: {
    style: '',
    image: icTHG,
    name: 'THG'
  }
};
export const itemTypeMap = {
  [BoxConfigRefType.COSMETIC]: {
    bgImg: bgOpenBox,
    bgStyle: 'cosmetic'
  },
  [BoxConfigRefType.HERO_SKIN]: {
    bgImg: bgOpenBox,
    bgStyle: ''
  },
  [BoxConfigRefType.PET]: {
    bgImg: bgOpenBox,
    bgStyle: ''
  },
  [BoxConfigRefType.CURRENCY]: {
    bgImg: bgOpenBox,
    bgStyle: ''
  }
};